export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: '结算单明细',
    field: 'expenseName',
    align: 'left',
    slots: {
      default: 'showShare'
    }
  },
]
